import React from 'react';

interface StatsCardProps {
  title: string;
  value: number;
  change?: number;
  icon: React.ReactNode;
  color: 'blue' | 'green' | 'yellow' | 'red';
}

const StatsCard: React.FC<StatsCardProps> = ({ title, value, change, icon, color }) => {
  // 잉크 디자인 통일: 색상 변형은 전부 그레이 스케일로 (경고성 red만 유지)
  const colorClasses = {
    blue: 'bg-gray-50 text-gray-900 border-gray-200',
    green: 'bg-gray-50 text-gray-900 border-gray-200',
    yellow: 'bg-gray-50 text-gray-500 border-gray-200',
    red: 'bg-red-50 text-red-600 border-red-200'
  };

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-6 hover:border-gray-300 transition-colors">
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-gray-600 mb-1">{title}</p>
          <p className="text-3xl font-bold text-gray-900 mt-2">
            {value.toLocaleString()}
          </p>
          {change !== undefined && (
            <p className={`text-sm mt-2 font-medium ${change >= 0 ? 'text-green-600' : 'text-red-600'}`}>
              {change >= 0 ? '↑' : '↓'} {Math.abs(change)}%
              <span className="text-gray-500 ml-1 font-normal">지난 30일</span>
            </p>
          )}
        </div>
        <div className={`p-4 rounded-lg border ${colorClasses[color]}`}>
          {icon}
        </div>
      </div>
    </div>
  );
};

export default StatsCard;

